<ng-container
  *ngLet="{
    exact: defaultedExact | async,
    disabled: defaultedDisabled | async,
    filterable: defaultedFilterable | async,
    options: defaultedOptions | async,
    optionsLoadable: optionsLoadable | async,
    placeholder: defaultedPlaceholder | async,
    positionedTop: positionedTop | async,
    selectedOption: defaultedSelectedOption | async,
    selectedId: selectedId | async,
    selectedDisplay: selectedDisplay | async,
    loadable: defaultedLoadable | async,
    inline: defaultedInline | async,
    open: openSubject | async
  } as vm"
>
  <div>
    <ng-container *ngIf="hasCustomDropdown(); else defaultDropdown">
      <div #dropdown (click)="!vm.disabled && doOpen.next(!vm.open)">
        <ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
      </div>
    </ng-container>
    <ng-template #defaultDropdown>
      <div
        #dropdown
        class="dropdown"
        [class.disabled]="vm.disabled"
        [class.placeholder]="!vm.disabled && !vm.selectedDisplay"
        [class.error]="error"
        [class.warning]="warning"
        [attr.tabindex]="vm.disabled ? null : 0"
        (click)="!vm.disabled && doOpen.next(!vm.open)"
        [focusOnInit]="autoFocus"
      >
        <ng-container
          *ngIf="vm.loadable && (vm.loadable.loading || vm.loadable.erred)"
        >
          <span class="display-value">&nbsp;</span>
          <loadable class="loading" [size]="16" [data]="vm.loadable"></loadable>
        </ng-container>
        <ng-container
          *ngIf="!vm.loadable || (!vm.loadable.loading && !vm.loadable.erred)"
        >
          <span class="display-value">
            {{ vm.selectedDisplay || vm.placeholder || '&nbsp;' }}
          </span>
        </ng-container>
        <div class="chevron">
          <riv-icon [name]="'ChevronDown'" [size]="16"></riv-icon>
        </div>
      </div>
    </ng-template>
    <ng-container *ngIf="vm.open && !vm.disabled">
      <deprecated-callout
        *deprecated-callout
        class="callout"
        [class.filterable]="vm.filterable"
        [anchor]="dropdownRef?.nativeElement"
        fallbackDirection="cw"
        [allowedPositions]="topAndBottomPositions"
        (actualPosition)="position.next($event)"
        (close)="doOpen.next(false)"
        [calloutHeight]="400"
        [cardStyling]="true"
        [scrollable]="scrollable"
      >
        <div
          class="callout-inner"
          [style.min-width.px]="dropdownWidth"
          #callout
        >
          <ng-content select="[top-callout]"></ng-content>
          <single-select
            #singleSelect
            [disabled]="vm.disabled"
            [displayId]="displayId"
            [options]="vm.options"
            [optionsLoadable]="vm.optionsLoadable"
            [exact]="vm.exact"
            [filterable]="vm.filterable"
            [selectedOption]="vm.selectedId"
            [filterPositionBottom]="vm.positionedTop"
            (selectedOptionChange)="selectedOptionIdChange.next($event)"
            (filterChange)="filter.next($event)"
            [maxElements]="maxElements"
          >
            <ng-container *ngIf="nodeDirective">
              <ng-container *singleSelectNode="let node">
                <ng-container
                  *ngTemplateOutlet="
                    nodeDirective.template;
                    context: {
                      $implicit: node,
                      clickHandler: singleSelect
                    }
                  "
                ></ng-container>
              </ng-container>
            </ng-container>
          </single-select>
          <ng-content></ng-content>
        </div>
      </deprecated-callout>
    </ng-container>
  </div>
</ng-container>
